export default "__VITE_ASSET__629dbae7__"